import { useSelector, useDispatch } from "react-redux";
import { subjectsOptions } from "../../../constants";
import OptionsDropDown from "../../UI/options_drop_down/options_drop_down";
import classes from "../criteriaSubmission.module.css";


const Subject = ({ isLoading, selectStoreData, setStoreData }) => {
  const storeData = useSelector(selectStoreData);
  const dispatch = useDispatch();

  const { subject } = storeData || {};

  const handleSubjectSelection = (event) => {
    const { value } = event.target;
    dispatch(setStoreData({ subject: value }));
    localStorage.setItem("subject", value);
  };

  return (
    <div className={classes["input-container"]}>
  <label className={classes.formLabel} htmlFor="subject">Select the subject you are teaching:</label>
      <OptionsDropDown
        name="subject"
        onChangeHandler={handleSubjectSelection}
        options={subjectsOptions}
        isDisabled={isLoading}
        isRequired={true}
        value={subject || ""}
      />
    </div>
  );
};

export default Subject;
